export const SuccessSnackbarIcon = (props) => (
  <svg
    width={185}
    height={247}
    viewBox="0 0 185 247"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-225.425 -8.66749C-183.733 -24.846 -134.709 -10.6495 -88.2039 -7.45969C-37.6162 -3.98987 35.6012 -23.7821 59.167 10.8528C86.6385 51.228 -10.506 97.645 11.9949 139.804C40.2322 192.711 169.75 187.65 183.525 243.857C194.663 289.302 107.434 312.282 61.5917 342.17C15.3087 372.345 -27.0876 431.265 -85.7527 419.417C-153.182 405.798 -159.93 332.351 -201.192 289.096C-220.338 269.025 -236.06 247.228 -263.072 233.529C-321.785 203.753 -434.776 216.64 -448.678 163.583C-461.026 116.456 -348.359 110.409 -304.249 76.3762C-271.638 51.2147 -266.655 7.33157 -225.425 -8.66749Z"
      fill="url(#paint0_linear_241_2661)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_241_2661"
        x1={-412.035}
        y1={109.273}
        x2={141.429}
        y2={370.322}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8CC63F" />
        <stop offset={0.217} stopColor="#60B641" />
        <stop offset={0.459} stopColor="#37A643" />
        <stop offset={0.679} stopColor="#199B44" />
        <stop offset={0.867} stopColor="#079445" />
        <stop offset={1} stopColor="#009245" />
      </linearGradient>
    </defs>
  </svg>
);

export const WarningSnackbarIcon = (props) => (
  <svg
    width={185}
    height={247}
    viewBox="0 0 185 247"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-225.425 -8.66749C-183.733 -24.846 -134.709 -10.6495 -88.2039 -7.45969C-37.6162 -3.98987 35.6012 -23.7821 59.167 10.8528C86.6385 51.228 -10.506 97.645 11.9949 139.804C40.2322 192.711 169.75 187.65 183.525 243.857C194.663 289.302 107.434 312.282 61.5917 342.17C15.3087 372.345 -27.0876 431.265 -85.7527 419.417C-153.182 405.798 -159.93 332.351 -201.192 289.096C-220.338 269.025 -236.06 247.228 -263.072 233.529C-321.785 203.753 -434.776 216.64 -448.678 163.583C-461.026 116.456 -348.359 110.409 -304.249 76.3762C-271.638 51.2147 -266.655 7.33157 -225.425 -8.66749Z"
      fill="red"
    />
  </svg>
);
